export default "/react/logoDailyGrow-6b1e49f2.png";